module.exports={author:"Franny Choi",date:"03/18/2022",publishDate:"03/18/2022",highlighted:!1,badge:"",tags:"",title:"Cuttings"};